import { Inject, inject, Injectable } from '@angular/core';
import { AutomationReplacementChipsDataService, PagedResponse } from '../common/components';
import { PipelinesApiService, Pipeline } from '@vendasta/crm';
import { AUTOMATION_NAMESPACE_INJECTION_TOKEN$ } from '@galaxy/automata/shared';
import { map, Observable, of, take } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CRMPipelineSelectorService implements AutomationReplacementChipsDataService<Pipeline> {
  private readonly pipelineService = inject(PipelinesApiService);
  supportsSearching = false;

  constructor(@Inject(AUTOMATION_NAMESPACE_INJECTION_TOKEN$) public readonly namespace$: Observable<string>) {}

  /* eslint-disable @typescript-eslint/no-unused-vars */
  doLookup(searchTerm: string, cursor: string, pageSize: number): Observable<PagedResponse<Pipeline>> {
    return this.namespace$.pipe(
      switchMap((namespace) =>
        this.pipelineService.listPipelines({
          listOptions: {
            namespace,
            objectType: 'Opportunity',
          },
        }),
      ),
      map((resp) => {
        return resp.pipelines;
      }),
      take(1),
      map((pipelines) => {
        return {
          results: pipelines,
          hasMore: false,
          nextCursor: '',
        };
      }),
    );
  }

  convertDataToDisplay(s: Pipeline): Observable<string> {
    return of(s?.name || '');
  }

  convertDataToFormValue(x: Pipeline): any {
    return x.pipelineId;
  }

  getMulti(pipelineIds: string[]): Observable<Pipeline[]> {
    return this.namespace$.pipe(
      switchMap((namespace) =>
        this.pipelineService.getMultiPipeline({
          namespace: namespace,
          pipelineIds: pipelineIds,
        }),
      ),
      map((resp) => resp?.pipelines || []),
    );
  }
}
